import { render, staticRenderFns } from "./FormResults.vue?vue&type=template&id=3499e464&scoped=true&"
import script from "./FormResults.vue?vue&type=script&lang=js&"
export * from "./FormResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499e464",
  null
  
)

export default component.exports